import { INetworkFilterFormOption, useWhitelabel } from 'main/framework'
import { palette, Text } from 'main/ui'
import React from 'react'

export default function NetworkRatingV2(props: {
  whitelabelRating: INetworkFilterFormOption | null
}) {
  const { whitelabelRating } = props
  const whitelabel = useWhitelabel()
  return (
    <Text css={{ color: palette.mediumGray, fontSize: `${14}px` }}>
      {whitelabelRating && (
        <span>
          {whitelabelRating.label}{' '}
          {whitelabel.networkRatingData().stars(whitelabelRating.symbolCount)}
        </span>
      )}
    </Text>
  )
}
